<template>
  <el-dialog :center="center" :close-on-click-modal="closeOnClickModal" :width="dialogWidth" :visible="dialogVisible" top="8vh" @close="closeDialog">
    <template #title>
      <span class="el-dialog__title">{{`${model.Id > 0 ? "编辑" : "添加"}服务记录`}}</span>
    </template>
    <div class="backgroud-white cs-editor-content">
      <el-form key="form" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :rules="rules" :model="model" label-width="80px">
        <el-form-item label="添加日期">
          <span>{{$moment(model.CreateDate).format("YYYY/MM/DD")}}</span>
        </el-form-item>
        <el-form-item label="服务日期" prop="ServiceDate">
          <el-date-picker align="center" size="small" format="yyyy/MM/dd" :disabled="readonly" v-model="model.ServiceDate" type="date" placeholder="选择服务日期" class="input-width" />
        </el-form-item>
        <el-form-item v-if="isTimeQuantity" label="服务时数" prop="QuantityDeduction">
          <el-input placeholder="请输入服务时数" :disabled="readonly" v-model="model.QuantityDeduction" oninput="value=value.replace(/[^0-9.]/g,'')"
            onblur="value=!!value?value.toNumber().toFixedEx(2):null" class="input-width">
            <template #append>
              <span>小时</span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="服务人员" prop="ServiceProvider">
          <el-input placeholder="请输入对接该服务人员的姓名" :disabled="readonly" v-model="model.ServiceProvider" class="input-width" />
        </el-form-item>
        <el-form-item label="备注" prop="Comment">
          <el-input type="textarea" :rows="5" resize="none" placeholder="选填" :disabled="readonly" v-model="model.Comment" class="input-width" />
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <div class="dialog-footer popup-footer">
        <el-row>
          <el-col>
            <el-button :disabled="readonly" type="primary" @click="saveChanges">确认</el-button>
          </el-col>
        </el-row>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { mixinDevice } from "@/core/mixin";

const mixin_generalMethods = {
  methods: {
    validate() {
      let isValid = true;

      this.model.QuantityDeduction = `${this.model.QuantityDeduction}`.toNumber();

      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.validate((valid) => {
          isValid = valid;
        });
      }

      return isValid;
    },
  },
};

const defaultData = {
  Id: 0,
  CreateDate: new Date(),
  WorkflowServiceItemId: 0,
  ServiceDate: null,
  QuantityDeduction: 1,
  ServiceProvider: null,
  Comment: null,
  Currency: 0,
  CostAmountDeduction: 0,
  SaleAmountDeduction: 0,
};

export default {
  name: "nonCourseServiceRecordEditor",
  mixins: [mixinDevice, mixin_generalMethods],
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "700px",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return Object.clone(defaultData);
      },
    },
    isTimeQuantity: {
      type: Boolean,
      default: false,
    },
    serviceHoursAvailable: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dialogVisible: false,
      rules: {
        ServiceDate: [
          {
            required: true,
            message: "请输入服务日期",
            trigger: "blur",
          },
        ],
        QuantityDeduction: [
          {
            required: true,
            message: "请输入服务时数",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              let fixedValue = `${value}`.toNumber();
              if (fixedValue === 0) {
                callback(new Error("请输入服务时数"));
                return;
              }

              if (this.serviceHoursAvailable - fixedValue < 0) {
                callback(new Error("不能大于可用时数"));
                return;
              }

              callback();
            },
            trigger: "blur",
          },
        ],
        ServiceProvider: [
          {
            required: true,
            message: "请输入服务人员",
            trigger: "blur",
          },
          {
            max: 250,
            message: "超过最大字数",
            trigger: "blur",
          },
        ],
        Comment: [
          {
            max: 2000,
            message: "超过最大字数",
            trigger: "blur",
          },
        ],
      },
      model: Object.clone(defaultData),
    };
  },
  created() {
    this.dialogVisible = this.visible;
  },
  computed: {
    dialogWidth() {
      return !this.isMobile() ? this.width : "100%";
    }
  },
  methods: {
    reloadModelFromDataIn() {
      if (!this.dialogVisible) return;

      this.model = Object.clone(!!this.data ? this.data : defaultData);
      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.resetFields();
      }
    },
    closeDialog() {
      this.$emit("close");
    },
    saveChanges() {
      let isValid = this.validate();
      if (!isValid) return;

      this.$emit("change", this.model);
    },
  },
  watch: {
    visible(newValue) {
      this.dialogVisible = newValue;

      if (this.visible) this.reloadModelFromDataIn();
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-editor-content {
  padding: 0 15%;
  overflow-y: auto;

  .el-form-item {
    margin-bottom: 12px;

    .input-width {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/serviceItem/nonCourseServiceRecordEditor.vue